import { ReactNode } from 'react';

export type TagProps = {
  children: ReactNode;
  className?: string;
  size?: Size;
};

export enum Size {
  sm = 'hot-tag--sm',
  md = '',
  lg = 'hot-tag--lg'
}
